// material-ui
import { Link, Container, Box } from '@mui/material';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useSelector } from 'react-redux';

const currentYear = new Date().getFullYear();

// ==============================|| FOOTER - AUTHENTICATION 2 & 3 ||============================== //

const Footer = () => {
  const siteInfo = useSelector((state) => state.siteInfo);

  return (
    <Container sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '64px' }}>
      <Box sx={{ textAlign: 'center' }}>
        {siteInfo.footer_html ? (
          <div className="custom-footer" dangerouslySetInnerHTML={{ __html: siteInfo.footer_html }}></div>
        ) : (
          <>
            {'© '}{currentYear}{' '}
            {siteInfo.system_name}{' · '}
            <Link component={RouterLink} to="/about">开源许可</Link>
          </>
        )}
      </Box>
    </Container>
  );
};

export default Footer;
